<template>
    <div class="vx-card p-8 flex flex-col gap-4">
        <vs-input class="border-grey-light w-1/3" type="text" v-model="appCondition.reference"
            :label="$t('admin.app-conditions.reference')" :danger="appCondition.reference == ''" />

        <Combobox
            v-model="appCondition.template"
            class="mt-4"
            :options="appConditionTemplates.map(template => ({key: template.id_ref, text: template.reference}))"
            :asyncFirstFetchCallback="fetchNewTemplates"
            :asyncNextFetchCallback="fetchNextTemplates"
            :label="$t('admin.app-conditions.template')"
        />

        <vs-input class="border-grey-light w-full" type="text" v-model="appCondition.company.name"
            :label="$t('admin.app-conditions.company.name')" :danger="appCondition.company.name == ''" />

        <Combobox
            v-model="appCondition.company.country"
            class="mt-4"
            :options="countries.map(country => ({key: country.code, text: (country.name ? country.name : '') + ' (' + country.code + ')'}))"
            :label="$t('admin.app-conditions.company.country')"
        />

        <vs-input class="border-grey-light w-full" type="text" v-model="appCondition.company.holder"
            :label="$t('admin.app-conditions.company.holder')" :danger="appCondition.company.holder == ''" />

        <vs-input class="border-grey-light w-full" type="text" v-model="appCondition.company.privacity_url"
            :label="$t('admin.app-conditions.company.privacity_url')" :danger="appCondition.company.privacity_url == ''" />

        <vs-input class="border-grey-light w-full" type="text" v-model="appCondition.company.document_id"
            :label="$t('admin.app-conditions.company.document_id')" :danger="appCondition.company.document_id == ''" />

        <vs-input class="border-grey-light w-full" type="text" v-model="appCondition.company.tax_address"
            :label="$t('admin.app-conditions.company.tax_address')" :danger="appCondition.company.tax_address == ''" />

        <vs-input class="border-grey-light w-full" type="text" v-model="appCondition.company.address"
            :label="$t('admin.app-conditions.company.address')" :danger="appCondition.company.address == ''" />

        <vs-input class="border-grey-light w-full" type="text" v-model="appCondition.company.privacity_email"
            :label="$t('admin.app-conditions.company.privacity_email')" :danger="appCondition.company.privacity_email == ''" />

        <div class="flex items-center ml-0 gap-4 mt-5">
            <vs-button :disabled="!isValid" class="rounded-lg xs:w-full sm:w-auto" @click="save">
                {{ $t('resorts.touristic-objects.form.saveButton') }}
            </vs-button>
            <vs-button type="border" class="rounded-lg xs:w-full sm:w-auto text-primary" @click="$router.push({'name': 'admin-app-conditions'})">
                {{ $t('resorts.touristic-objects.form.cancelButton') }}
            </vs-button>
        </div>
    </div>
</template>

<script>

import store from "@/modules/Shared/Store/store";
import loader from "@/modules/Shared/Mixins/loader";
import Combobox from "@/modules/Shared/Components/Combobox.vue";
import PaginationService from "@/modules/Shared/Services/PaginationService";
import appConditionService from "@/modules/Admin/Services/AppConditionsService";
import LocalizedContent from '@/modules/Shared/Components/form/LocalizedContent'
import { unifyPaginatedResponse } from "@/modules/Shared/Helpers/apiResponseHelper";
import { isPickerMode, notifyCreatedAndClose } from "@/modules/Shared/Helpers/creatableSelectPicker";

export default {
    name: "EditAppConditionPage",
    components: { LocalizedContent, Combobox },
    mixins: [loader],
    data() {
        return {
            countries: [],
            templatesComboboxPage: 1,
            templatesComboboxEnded: false,
            appConditionTemplates: [],
            appCondition: {
                uuid: "",
                reference: "",
                template: "",
                company: {
                    name: "",
                    countryCode: "",
                    holder: "",
                    privacityUrl: "",
                    documentId: "",
                    tax_address: "",
                    address: "",
                    privacityEmail: "",
                }
            },
            new: true,
        }
    },

    computed: {
        isValid() {
            return this.appCondition.reference && 
                this.appCondition.company.name &&
                this.appCondition.company.country &&
                this.appCondition.company.holder &&
                this.appCondition.company.privacity_url &&
                this.appCondition.company.document_id &&
                this.appCondition.company.tax_address &&
                this.appCondition.company.address &&
                this.appCondition.company.privacity_email
        }
    },

    async beforeRouteEnter(to, from, next) {
        try {
            const appCondition = await appConditionService.getAppCondition(to.params.uuid);
            await store.dispatch('setRouteElement', appCondition)
            next(vm => {
                vm.appCondition = appCondition
                vm.new = false
            })
        } catch (error) {
            await store.dispatch('setRouteElement', null)
            next(vm => {
                vm.appCondition = {
                    uuid: to.params.uuid,
                    id_ref: "",
                    template: "",
                    company: {
                        name: "",
                        country_code: "",
                        holder: "",
                        privacity_url: "",
                        document_id: "",
                        tax_address: "",
                        address: "",
                        privacity_email: "",
                    }
                }
            })
        }
    },
    async created() {
        this.loadAndNotifyError(async () => {
            let currentTemplate = null;
            [this.countries, currentTemplate] = await Promise.all([
                unifyPaginatedResponse(appConditionService.getCountryDataAuthorities),
                appConditionService.getAppConditionTemplates({ 'q': 'reference:' + this.appCondition.template }, 1)
            ])

            this.appConditionTemplates = currentTemplate.data;
        })
    },
    methods: {
        save() {
            this.loadAndNotify(async () => {
                if (this.new) {
                    await appConditionService.createAppCondition(this.$route.params.uuid, this.appCondition);
                } else {
                    await appConditionService.updateAppCondition(this.appCondition.uuid, this.appCondition);
                }

                if (isPickerMode(this.$route) && notifyCreatedAndClose({
                    uuid: this.$route.params.uuid,
                    reference: this.appCondition.reference,
                })) {
                    return
                }

                this.$router.push({'name': 'admin-app-conditions'});
            })
        },

        async fetchTemplates(filter, page = 1) {
            const response = await appConditionService.getAppConditionTemplates(
                filter ? PaginationService.parseParameters({
                    filters: [ { field: 'reference', value: filter } ],
                    per_page: 30,
                }) : {per_page: 30}, 
                page
            )

            if (response.data.length < 30) {
                this.templatesComboboxEnded = true
            }

            this.appConditionTemplates = [...this.appConditionTemplates, ...response.data]
        },

        fetchNextTemplates(filter) {
            if (this.templatesComboboxEnded) {
                return
            }
            this.templatesComboboxPage += 1
            return this.fetchTemplates(filter, this.templatesComboboxPage)
        },

        fetchNewTemplates(filter) {
            this.appConditionTemplates = []
            this.templatesComboboxPage = 1
            return this.fetchTemplates(filter, this.templatesComboboxPage)
        },
    }
};
</script>